import purchaseView from '../../../../components/reimbursement/purchaseView'
import PublicBuill from '../../../../components/reimbursement/js/publicBuill'
import axios from 'axios'

export default {
  name: 'unfiledPurchase',
  components: {
    purchaseView
  },
  data() {
    return {
      treeData: [{
        label: '全部',
        children: [
        ]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      queryData: {
        gys: '',
        jbr: '',
        dycs: '全部',
        settleMode: '',
        roles: 'wzyb,fms,actuator,ic'
      },
      tableData: [],
      currentPage: 1,
      total: 0,
      limit: 200,
      documentType: 'all',
      role: '',
      dialogTitle: '',
      cnConfirm: {
        zffs: '',
        ph: ''
      },
      rowData: {},
      /* 查看组件 */
      purchaseShow: false,
      sumArr: ['合计', '', '', '', '', '', '', '', '', '', '']


    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs['cnTatel'].doLayout()
    })
  },
  created() {
    PublicBuill.setThis(this)
    this.findPage()
  },
  methods: {
    Nindex(index) {
      const page = this.currentPage
      const pageSize = this.limit
      return index + 1 + (page - 1) * pageSize
    },
    /* 查询列表数据 */
    findPage() {
      const loading = this.$loading({
        lock: true,
        text: '查询中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        gys: this.queryData.gys ? this.queryData.gys : null,
        lrrname: this.queryData.jbr ? this.queryData.jbr : null,
        settleMode: this.queryData.settleMode === '' ? null : this.queryData.settleMode,
        documentType: this.queryData.roles,
        limit: this.limit,
        currentPage: this.currentPage
      }
      this.$post('/fesback/statistics/unfiledPurchaseTotal.z', data).then(res => {
        if (res.data) {
          const je = PublicBuill.formatAmount(res.data.je.toFixed(2))
          const tgje = PublicBuill.formatAmount(res.data.tgje.toFixed(2))
          const yfk = PublicBuill.formatAmount(res.data.yfk.toFixed(2))
          const qk = PublicBuill.formatAmount(res.data.qk.toFixed(2))
          this.sumArr = ['合计', '', '', '', '', '', je, tgje, yfk, qk, '']
        }
      })
      this.$post('/fesback/statistics/unfiledPurchase.z', data).then(request => {
        PublicBuill.purchaseJeFormatter(request.data.data)
        this.tableData = request.data.data
        this.total = request.data.count
        loading.close()

      }).catch(res => {
        loading.close()
        this.$message.error(res)
      })

    },
    /* 分页 */
    handleSizeChange(val) { // 每页多少条
      this.limit = val
      this.findPage()
    },
    handleCurrentChange(val) { // 当前页
      this.currentPage = val
      this.findPage()
    },
    view(index, row) {
      const loading = this.$loading({
        lock: true,
        text: '查询中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.rowData = row
      this.purchaseShow = true
      setTimeout(function a() {
        loading.close()
      }, 3000)
    },
    rqFormatter(row, column, cellValue, index) {
      const arr = row.rq.split('.')
      return arr[0]
    },
    ywbmFormatter(row) {
      if (row.documentType === 'fms') return row.ywbm
      return row.documentType === 'wzyb' ? '吴忠仪表' : (row.documentType === 'ic' ? '装备公司' : '执行器公司')
    },
    dycsFormatter(row) {
      return row.dycs === '0' ? '未打印' : '已打印'
    },
    getSummaries(param) {
      return this.sumArr
    },
    exportUnfiledPurchase() {
      const loading = this.$loading({
        lock: true,
        text: '请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        gys: this.queryData.gys ? this.queryData.gys : null,
        lrrname: this.queryData.jbr ? this.queryData.jbr : null,
        settleMode: this.queryData.settleMode === '' ? null : this.queryData.settleMode,
        documentType: this.queryData.roles
      }
      axios.post(
        '/fesback/statistics/exportUnfiledPurchase.z',
        data,
        {
          responseType: 'blob'
        }
      ).then(res => {
        loading.close()
        const fileName = '未归档采购付款单据' + '.xlsx'
        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        const a = document.createElement('a')
        const href = URL.createObjectURL(blob)
        a.href = href
        a.setAttribute('download', fileName)
        a.click()
        URL.revokeObjectURL(href)
      })
    }
  }
}
